import { render, staticRenderFns } from "./guestAdmin.vue?vue&type=template&id=3dec33b6&scoped=true"
import script from "./guestAdmin.vue?vue&type=script&lang=js"
export * from "./guestAdmin.vue?vue&type=script&lang=js"
import style0 from "./guestAdmin.vue?vue&type=style&index=0&id=3dec33b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec33b6",
  null
  
)

export default component.exports